import { ref } from 'vue';

export const AI_CONSENT_VERSION = 1;
export const AI_CONSENT_STORAGE_KEY_PREFIX = 'ai_consent_accepted';
const LEGACY_AI_CONSENT_STORAGE_KEY = 'ai_consent_accepted';

export const AI_CONSENT_TEXT =
	'Para gerar respostas, suas mensagens serão enviadas para um serviço de inteligência artificial utilizado pelo aplicativo. Ao continuar, você concorda com esse processamento de dados para fornecimento das funcionalidades do chat.';

export function getAiConsentStorageKey(userId) {
	if (!userId) {
		return null;
	}

	return `${AI_CONSENT_STORAGE_KEY_PREFIX}_v${AI_CONSENT_VERSION}_${userId}`;
}

function removeLegacyAiConsent() {
	try {
		localStorage.removeItem(LEGACY_AI_CONSENT_STORAGE_KEY);
	} catch (error) {
		window.console.warn('Não foi possível remover consentimento legado de IA:', error);
	}
}

export function isAiConsentAccepted(userId) {
	const storageKey = getAiConsentStorageKey(userId);
	if (!storageKey) {
		return false;
	}

	try {
		removeLegacyAiConsent();
		return localStorage.getItem(storageKey) === 'true';
	} catch (error) {
		window.console.warn('Não foi possível ler o consentimento de IA:', error);
		return false;
	}
}

export function saveAiConsent(userId) {
	const storageKey = getAiConsentStorageKey(userId);
	if (!storageKey) {
		return;
	}

	try {
		removeLegacyAiConsent();
		localStorage.setItem(storageKey, 'true');
	} catch (error) {
		window.console.warn('Não foi possível salvar o consentimento de IA:', error);
	}
}

export function useAiConsent() {
	const showAiConsentDialog = ref(false);
	let pendingAction = null;
	let pendingUserId = null;

	function promptConsentIfNeeded(userId) {
		if (isAiConsentAccepted(userId)) {
			return;
		}

		pendingUserId = userId;
		pendingAction = null;
		showAiConsentDialog.value = true;
	}

	function withConsent(action, userId) {
		if (typeof action !== 'function') {
			return;
		}

		if (isAiConsentAccepted(userId)) {
			action();
			return;
		}

		pendingAction = action;
		pendingUserId = userId;
		showAiConsentDialog.value = true;
	}

	function acceptConsent() {
		saveAiConsent(pendingUserId);
		showAiConsentDialog.value = false;

		const action = pendingAction;
		pendingAction = null;
		pendingUserId = null;

		if (action) {
			action();
		}
	}

	function cancelConsent() {
		const shouldCloseChat = !pendingAction;

		showAiConsentDialog.value = false;
		pendingAction = null;
		pendingUserId = null;

		return { shouldCloseChat };
	}

	return {
		showAiConsentDialog,
		promptConsentIfNeeded,
		withConsent,
		acceptConsent,
		cancelConsent,
		isAiConsentAccepted,
	};
}
